import React, { useEffect, useState } from 'react'
import './App.scss'
import Portal from './Portal'
import {
  AddProjectResourceAction,
  AddProjectAction,
  DealerLocatorView,
  ProjectMenu,
  ResourceMenu,
  RepLocatorView,
  AddProjectCustomProductAction,
} from './components'
import { useI18n } from '@ggs/i18n'
import { get } from 'lodash'

/**
 * React application components initialization.
 * @return {JSX.Element}
 */
function App() {
  const { changeLanguage } = useI18n()
  const [languageReady, setLanguageReady] = useState(false)
  const languageCode = get(window || {}, `drupalSettings.path.currentLanguage`, 'en')

  useEffect(() => {
    changeLanguage(languageCode)
    setLanguageReady(true)
    console.log('SetDrupalLanguage:', languageCode)
  }, [languageCode])

  // Wait that language resolution is done before rendering components.
  if (!languageReady) {
    return null
  }

  return (
    <div className="App">
      <Portal containerId='react-add-resource' multiple={true}>
        <AddProjectResourceAction />
      </Portal>
      <Portal containerId='react-resource-menu' multiple={true}>
        <ResourceMenu />
      </Portal>
      <Portal containerId='react-project-menu' multiple={true}>
        <ProjectMenu />
      </Portal>
      <Portal containerId='react-add-project' multiple={true}>
        <AddProjectAction />
      </Portal>
      <Portal containerId='react-dealer-locator' multiple={false}>
        <DealerLocatorView />
      </Portal>
      <Portal containerId='react-rep-locator' multiple={false}>
        <RepLocatorView />
      </Portal>
      <Portal containerId='react-add-project-custom-product' multiple={false}>
        <AddProjectCustomProductAction />
      </Portal>
    </div>
  )
}

export default App
